{
  "data": {
    "simple": "simple_list",
    "near": "nearby_terms",
    "combinations": "expressions_combinations",
    "exclude": "terms_to_exclude"
  }
}
